
import React from "react";
import { Routes, Route } from "react-router-dom";
import AuthCallback from "@/pages/AuthCallback";
import ResetPassword from "@/pages/ResetPassword";
import SetPassword from "@/pages/SetPassword";

const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="/callback" element={<AuthCallback />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/set-password" element={<SetPassword />} />
    </Routes>
  );
};

export default PublicRoutes;
